// @flow
import React, { PureComponent, Fragment } from 'react'
import _throttle from 'lodash/throttle'
import type { Booking as BookingType } from 'src/types'
import { roundToTwo } from 'src/helpers/normalize'
import BookingModal from './BookingModal'
import {
  HeaderWrapper,
  HeaderContent,
  RoomName,
  RoomInfoText,
  StyledButton
} from './StyledElements'

type Props = {
  booking: BookingType,
  bookingDeposit: string,
  adminFee: string,
  paymentPlan: string
}
type State = {
  isShown: boolean,
  isOpen: boolean
}

class StickyMobileHeader extends PureComponent<Props, State> {
  state = {
    isShown: false,
    isOpen: false
  }
  _triggerAfter = 100

  _throttledListener = () => {}
  _throttledResizeHandler = () => {}
  constructor(props: Props) {
    super(props)
    this._throttledListener = _throttle(this.checkVisible, 100)
    this._throttledResizeHandler = _throttle(this.resizeHandler, 100)
  }

  checkVisible = () => {
    const { isShown } = this.state
    if (!isShown && window.scrollY >= this._triggerAfter) {
      this.setState({ isShown: true })
    } else if (isShown && window.scrollY < this._triggerAfter) {
      this.setState({ isShown: false })
    }
  }

  resizeHandler = () => {
    const mql = window.matchMedia('(min-width: 1024px)')
    if (mql.matches) {
      // close modal on desktop
      this._closeModal()
    }
  }

  _openModal = () => this.setState({ isOpen: true })

  _closeModal = () => this.setState({ isOpen: false })

  _openDetailPanel = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }))
  }
  componentDidMount() {
    window.addEventListener('scroll', this._throttledListener)
    window.addEventListener('resize', this._throttledResizeHandler)
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this._throttledListener)
    window.removeEventListener('resize', this._throttledResizeHandler)
  }

  render() {
    const { isShown = false, isOpen = false } = this.state
    const { booking, adminFee, bookingDeposit, paymentPlan } = this.props
    const {
      room: { type }
    } = booking
    return (
      <Fragment>
        <HeaderWrapper isShown={isShown} isOpen={isOpen}>
          <HeaderContent>
            <RoomName>{type}</RoomName>
            <RoomInfoText>
              Total today £{roundToTwo(Number(adminFee) + Number(bookingDeposit))}
            </RoomInfoText>
          </HeaderContent>
          <StyledButton onClick={this._openModal}>View</StyledButton>
        </HeaderWrapper>
        <BookingModal
          booking={booking}
          open={isOpen}
          toClose={this._closeModal}
          adminFee={adminFee}
          paymentPlan={paymentPlan}
          bookingDeposit={bookingDeposit}
          roomType={type}
        />
      </Fragment>
    )
  }
}

export default StickyMobileHeader



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/components/MobileHeader/StickyMobileHeader.js